import * as React from 'react';
import {Main} from "../components/Main";
import imgAktywacja from "../images/ins-aktywacja.jpg";
import imgMigracja from "../images/ins-migracja.jpg";

const GOOGLE_PLAY = 'https://play.google.com/store/apps/details?id=topsa.merkurymarket.ekarta';

interface Krok {
    tytul: string,
    opis?: React.ReactNode
}

const KROK_INSTALACJA: Krok = {
    tytul: 'Zainstaluj aplikację mobilną Merkury Market z Google Play',
    opis: <>Zeskanuj kod QR z grafiki lub <a href={GOOGLE_PLAY}>pobierz aplikację z Google Play</a>.</>
};
const KROK_REJESTRACJA: Krok = {tytul: 'Zarejestruj konto w aplikacji'};
const KROK_LINK: Krok = {tytul: 'Potwierdź link aktywacyjny wysłany na Twojego maila'};
const KROK_KOD: Krok = {tytul: 'Pokaż kasjerowi kod kreskowy', opis: 'Kod znajduje się w zakładce KARTA.'};
const KROK_ZAKUPY: Krok = {tytul: 'Zrób zakupy w sklepie Merkury Market', opis: 'Płacąc za zakupy użyj aplikacji z zalogowanym kontem.'};
const KROK_AKTYWNA: Krok = {tytul: 'Karta zostaje aktywowana'};

const KROKI_AKTYWACJA = [KROK_INSTALACJA, KROK_REJESTRACJA, KROK_LINK, KROK_KOD, KROK_ZAKUPY, KROK_AKTYWNA];
const KROKI_MIGRACJA = [KROK_INSTALACJA, KROK_REJESTRACJA, KROK_LINK, {tytul: 'Podaj kasjerowi swoją kartę stałego klienta'}, KROK_KOD, KROK_ZAKUPY, KROK_AKTYWNA];

const WersjaTekstowa = (props: {kroki: Krok[]}) =>
    <details className={'wersja-tekstowa'}>
        <summary>Wersja tekstowa instrukcji</summary>
        <ol>
            {props.kroki.map((krok, i) =>
                <li key={i}><b>{krok.tytul}</b>{krok.opis && <><br/>{krok.opis}</>}</li>
            )}
        </ol>
    </details>

export class Instrukcje extends React.Component<any> {

    render() {
        return <Main active={'INSTRUKCJE'} title={'Instrukcje'}>
            <h1 className={'sr-only'}>Instrukcje</h1>
            <div className={'row'}>
                <div className={'col-xl-6'} style={{marginBottom: '15px'}}>
                    <div id={'main-container'} style={{marginTop: '0', paddingTop: '15px'}}>
                        <h2 id={'aktywacja'} className={'h3'} style={{textAlign: 'center'}}>Aktywacja ekarty</h2>
                        <img src={imgAktywacja} className={'card-img'}
                             alt={'Instrukcja aktywacji e-karty krok po kroku. Wersja tekstowa poniżej.'}/>
                        <WersjaTekstowa kroki={KROKI_AKTYWACJA}/>
                    </div>
                </div>
                <div className={'col-xl-6'} style={{marginBottom: '15px'}}>
                    <div id={'main-container'} style={{marginTop: '0', paddingTop: '15px'}}>
                        <h2 id={'migracja'} className={'h3'} style={{textAlign: 'center'}}>Migracja z karty plastikowej</h2>
                        <img src={imgMigracja} className={'card-img'}
                             alt={'Instrukcja migracji z karty plastikowej krok po kroku. Wersja tekstowa poniżej.'}/>
                        <WersjaTekstowa kroki={KROKI_MIGRACJA}/>
                    </div>
                </div>
            </div>
        </Main>
    }
}

export default Instrukcje;
